import { agentProductionTerms, MLS_PROPERTY_TYPE_CLASS_ID } from "../../../../constants";
import { favoriteAgentTerms } from "../../../constants/agentProductionConstants";
import { getFooterTimePeriodValue } from "../../suggestedAgents/helpers/helpers";

export const getPropertyTypeValues = (propertyTypes, keyToMap) => {
    if (!propertyTypes.length) return;
    let revisedPropertyTypes = [];
    for (let obj of propertyTypes) {
        const properties = obj?.types
            .filter(obj => keyToMap in obj)
                .map(obj => String(obj[keyToMap]));
        revisedPropertyTypes = [...revisedPropertyTypes, ...properties];
    };
    return Array.from(new Set(revisedPropertyTypes));
};

export const getSearchCriteriaPropertyTypes = (propertyTypes) => {
    const propertyTypeCategories = MLS_PROPERTY_TYPE_CLASS_ID['RESIDENTIAL'];
    return propertyTypes.filter((obj) => obj.classId === propertyTypeCategories);
};

export const popoverIds = Object.freeze({
    display: 'display-dropdown',
    metrics: 'metrics-dropdown'
});

export const recentSortFunction = (selectedId) => (a, b) => {
    if (a.agentListId === selectedId) return -1;
    if (b.agentListId === selectedId) return 1;
    const getDate = (obj) => new Date(obj?.lastLoadTs);
    return getDate(b) - getDate(a);
};

export const getSelectedAgentList = (agentLists, selectedSavedAgentListId) => {
    if (!selectedSavedAgentListId) {
        return [...agentLists].sort(recentSortFunction())[0];
    }

    const isAllListsSelected = selectedSavedAgentListId?.toString()?.includes('all-lists');
    if (isAllListsSelected) {
        const mlsId = parseInt(selectedSavedAgentListId.split('-')[2], 10);
        const agentIds = agentLists
            .filter(agent => agent.mlsId === mlsId)
            .flatMap(agent => agent.agentIds);

        return {
            agentListId: selectedSavedAgentListId,
            name: favoriteAgentTerms.reservedListName,
            mlsId,
            agentIds: [...new Set(agentIds)]
        };
    }
    return agentLists.find(list => list.agentListId === selectedSavedAgentListId);
};

export const getFooterLabels = ({ loadedSearchFields, selectedTimePeriod, propertyTypes }) => {
    const selectedArea =
        loadedSearchFields &&
        loadedSearchFields?.searchFields?.find((sf) => sf.fieldName !== 'propertyType');
    const areaLabel =
        loadedSearchFields && loadedSearchFields?.searchAllMLS
            ? agentProductionTerms.allMls
            : `${selectedArea?.fieldTypeName}: ${selectedArea?.fieldValues?.join(', ')}`;

    const getFormattedDates = (selectedTimePeriod) => {
        if (!selectedTimePeriod) return;
        return {
            from: new Date(selectedTimePeriod?.last?.from),
            to: new Date(selectedTimePeriod?.last?.to)
        };
    };

    const timePeriodTitle = getFooterTimePeriodValue(
        getFormattedDates(selectedTimePeriod)
    );

    const getSelectedPropertyTypesLabel = (propertyClasses, searchFields) => {
        if (!searchFields || !propertyClasses) return '';
        const selectedIds = searchFields.flatMap((field) => field.fieldValues.map(Number));
        const classNames = [];
        const revisedPropertyTypes = [];

        for (const selectedId of selectedIds) {
            for (const propertyClass of propertyClasses) {
                const type = propertyClass.types.find((pt) => pt.typeId === selectedId);
                if (!type) continue;
                if (!classNames.includes(propertyClass.longName)) {
                    classNames.push(propertyClass.longName);
                }
                revisedPropertyTypes.push(type.longName);
                break;
            }
        }
        return `${classNames.join(', ')}: ${revisedPropertyTypes.join(', ')}`;
    };
    const propertyTypeFooterLabel = getSelectedPropertyTypesLabel(
        propertyTypes,
        loadedSearchFields?.searchFields
    );

    return {
        areaLabel,
        timePeriodTitle,
        propertyTypeFooterLabel
    };
};
